import ResultQuestion from './ResultQuestion'

export default ResultQuestion
